module.exports = __webpack_public_path__ + "media/images/svg/thumb-up-0e6446534c99dcc654df0229f0a07653.svg";